import { render, staticRenderFns } from "./OrganisationDashboardSelfRegistration.vue?vue&type=template&id=94197eac&"
import script from "./OrganisationDashboardSelfRegistration.vue?vue&type=script&lang=ts&"
export * from "./OrganisationDashboardSelfRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94197eac')) {
      api.createRecord('94197eac', component.options)
    } else {
      api.reload('94197eac', component.options)
    }
    module.hot.accept("./OrganisationDashboardSelfRegistration.vue?vue&type=template&id=94197eac&", function () {
      api.rerender('94197eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/organisationDashboard/OrganisationDashboardSelfRegistration.vue"
export default component.exports